// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__doSeA","custom-header":"navbar_custom-header__dQax0","custom-body":"navbar_custom-body__Gnzmp"};